import React, { useEffect, useState, useContext, useCallback, useMemo, useRef } from "react";
import { Box, Typography, IconButton, Tooltip, Collapse, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress, Checkbox, FormControl, FormControlLabel, InputLabel, Menu, MenuItem, Select } from "@mui/material";
import { ROLE_OPTIONS } from '../../../../utils/roleOptions'
import { useParams, useHistory, Link } from "react-router-dom";
import axios from "axios";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import { Formik, Form } from "formik";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import Alert from "react-bootstrap/Alert";
// # REMOVED AS PART OF 19.2 UPGRADE
//import { CommentSection } from "react-comments-section";
//import "react-comments-section/dist/index.css";
import { Avatar } from "@mui/material";
import { format } from "date-fns";
// Icons
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import UpdateIcon from '@mui/icons-material/Update';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DescriptionIcon from '@mui/icons-material/Description';
import PaymentsIcon from '@mui/icons-material/Payments';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FireplaceIcon from "@mui/icons-material/Fireplace";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import MessageIcon from "@mui/icons-material/Message";
import CodeIcon from "@mui/icons-material/Code";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import AssistantIcon from "@mui/icons-material/Assistant";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import TimelineIcon from '@mui/icons-material/Timeline';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import TodayIcon from "@mui/icons-material/Today";
import BuildIcon from "@mui/icons-material/Build"; // wrench
import { AuthContext } from "../../../../helpers/AuthContext";
import ReactionButtons from "./reaction";
import {
  MessageCircle,
  ThumbsUp,
  ThumbsUpIcon,
  Delete,
  Trash,
} from "lucide-react";
import Modal from "react-bootstrap/Modal";
import Comments from "./comments";
import notifyUsers from "../../../essentials/notification";
import "./style.css";

import Swal from "sweetalert2";
import { formatDistanceToNow } from "date-fns";

import CelebrationIcon from "@mui/icons-material/Celebration";
import {
  companyUpdateFilterParams,
  filterCompanyUpdates,
  NOTE_ACTIVITY_FILTERS,
} from "../../../../utils/noteActivityFilters";
import { getNoteActionDefinition } from "../../../../constants/noteActionRegistry";
import EmailViewerDialog from "../../../../components/EmailViewer/EmailViewerDialog";
import { buildEmailNotePreview, buildEmailViewerPropsFromNote, canViewEmailNote } from "../../../../utils/emailViewerNotes";
import FinanceFeedHome, { shouldShowFinanceFeedHome } from "./components/FinanceFeedHome";

function InstanceFeedAndActivity() {
  let { instanceUniqueId } = useParams();
  const [postObject, setPostObject] = useState({});
  const [listOfActiveCores, setListOfActiveCores] = useState([]);
  const [listOfLeads, setListOfLeads] = useState([]);
  const [avatarPreview, setAvatarPreview] = useState(
    "/elite-core-brand-logo.png"
  );
  const [avatarField, setAvatarField] = useState("");
  const [checkIfCardIsValid, setCheckIfCardIsValid] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const { authState } = useContext(AuthContext);
  const canChangeBrandLogo = [authState?.role, ...(Array.isArray(authState?.roles) ? authState.roles : [])]
    .some((role) => String(role || "").trim().toLowerCase().replace(/[_\s]+/g, "-") === "super-administrator");

  const { id } = useParams();
  const [feedTab, setFeedTab] = useState("company-updates");
  const [activityUpdates, setActivityUpdates] = useState([]);
  const [activityPage, setActivityPage] = useState(1);
  const [hasMoreActivity, setHasMoreActivity] = useState(true);
  const [loadingActivity, setLoadingActivity] = useState(true);
  const [loadingMoreActivity, setLoadingMoreActivity] = useState(false);
  const [activityError, setActivityError] = useState("");
  const [companyUpdates, setCompanyUpdates] = useState([]);
  const [companyUpdatesPage, setCompanyUpdatesPage] = useState(1);
  const [hasMoreCompanyUpdates, setHasMoreCompanyUpdates] = useState(true);
  const [loadingCompanyUpdates, setLoadingCompanyUpdates] = useState(true);
  const [loadingMoreCompanyUpdates, setLoadingMoreCompanyUpdates] = useState(false);
  const [companyUpdatesError, setCompanyUpdatesError] = useState("");
  const [companyUpdatesLoaded, setCompanyUpdatesLoaded] = useState(false);
  const [companyUpdatesUnfilteredTotal, setCompanyUpdatesUnfilteredTotal] = useState(0);
  const [activeCompanyEmailNote, setActiveCompanyEmailNote] = useState(null);
  const [activityFilter, setActivityFilter] = useState("all");
  const [hideCartChanges, setHideCartChanges] = useState(true);
  const [companyFilterAnchorEl, setCompanyFilterAnchorEl] = useState(null);
  const [activityLoaded, setActivityLoaded] = useState(false);
  const loadMoreRef = useRef(null);
  const [newStatus, setNewStatus] = useState(""); // Text for new status update
  const [likedPosts, setLikedPosts] = useState({}); // Store likes for each post
  const [commentsModal, setCommentsModal] = useState(false); // Store likes for each post
  const [selectedItem, setSelectedItem] = useState({}); // Store likes for each post
  const [userDetails, setUserDetails] = useState(null);
  const [postComment, setPostComment] = useState(null);
  const [comments, setComments] = useState([]); // State to hold comments
  const [postModal, setPostModal] = useState(false); // Store likes for each post
  const [openComments, setOpenComments] = useState({});

  const [statusTitle, setStatusTitle] = useState(""); // New state for title input

  const defaultAvatarUrl = "/elite-core-placeholder-avatar.png";

  
  const ACTION_META = {
    'sent-email':         { icon: <MailOutlineIcon fontSize="small" />,       label: 'Email Sent',          color: '#1976d2' /* blue */ },
    'update':             { icon: <UpdateIcon fontSize="small" />,            label: 'Customer Updated',             color: '#0288d1' /* light blue */ },
    'approve':            { icon: <CheckCircleIcon fontSize="small" />,      label: 'Approved',            color: '#2e7d32' /* green */ },
    'decline':            { icon: <CancelIcon fontSize="small" />,           label: 'Declined',            color: '#c62828' /* red */ },
    'order-create':          { icon: <ShoppingCartIcon fontSize="small" />,     label: 'New Order',           color: '#ff8f00' /* amber */ },
    'presentation-generate':   { icon: <SlideshowIcon fontSize="small" />,        label: 'New Presentation',    color: '#6a1b9a' /* purple */ },
    'presentation-comment':   { icon: <SlideshowIcon fontSize="small" />,        label: 'Presentation Comment',    color: '#6a1b9a' /* purple */ },
    'estimate-create':       { icon: <ReceiptLongIcon fontSize="small" />,      label: 'New Estimate',        color: '#00796b' /* teal */ },
    'new-sales-order':    { icon: <MonetizationOnIcon fontSize="small" />,   label: 'New Sales Order',     color: '#afb42b' /* lime */ },
    'purchase-order-create': { icon: <LocalOfferIcon fontSize="small" />,       label: 'New Purchase Order',  color: '#5d4037' /* brown */ },
    'new-invoice':        { icon: <DescriptionIcon fontSize="small" />,     label: 'New Invoice',         color: '#283593' /* indigo */ },
    'new-bill':           { icon: <PaymentsIcon fontSize="small" />,        label: 'New Bill',            color: '#c79100' /* golden */ },
    'completed-order':    { icon: <DoneAllIcon fontSize="small" />,         label: 'Order Completed',     color: '#388e3c' /* dark green */ },
  };

  // Helper to get a fully qualified URL for a user’s profile picture.
  const getUserAvatar = (user) => {
    if (!user || !user.profilePicture) return defaultAvatarUrl;
    let profilePic = user.profilePicture;
    // If stored as a JSON string, parse it.
    if (typeof profilePic === "string") {
      try {
        profilePic = JSON.parse(profilePic);
      } catch (e) {
        console.error("Error parsing profilePicture JSON:", e);
        return defaultAvatarUrl;
      }
    }
    if (Array.isArray(profilePic) && profilePic.length > 0) {
      // Prefer the image marked as selected (or use the first one)
      const selected = profilePic.find((p) => p.selected) || profilePic[0];
      if (selected && typeof selected.url === "string") {
        // If the URL is relative (e.g., starts with "uploads"), prepend the server URL.
        if (selected.url.startsWith("uploads")) {
          return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${selected.url}`;
        }
        return selected.url;
      }
    }
    return defaultAvatarUrl;
  };

  // Helper function: if brandLogo starts with "uploads" (i.e. a relative path),
  // then return the full URL by prepending the server base URL.
  const getBrandLogoUrl = () => {
    if (
      typeof avatarPreview === "string" &&
      avatarPreview.startsWith("uploads")
    ) {
      return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${avatarPreview}`;
    }
    return avatarPreview;
  };

  let img = "https://elitedigitalmarketing.ca/wp-content/uploads/Gord.jpg";

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserDetails(decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    } else {
      console.log("No token found in localStorage.");
    }
  }, []);

  const accessToken = localStorage.getItem("accessToken");

  const handleCommentSubmit = async (data, postId) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("Access token not found");
      return;
    }

    const commentData = {
      postId: postId,
      // userId: data.userId,
      comment: data.text,
      // Add other necessary fields based on your API requirements
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/news-feed/comment/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(commentData),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      fetchActivityUpdates(1, false);
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const toggleComments = (postId) => {
    setOpenComments((prevOpenComments) => ({
      ...prevOpenComments,
      [postId]: !prevOpenComments[postId],
    }));
  };

  const normalizedRole = String(authState?.role || "").trim().toLowerCase().replace(/_/g, '-');
  const currentRoleLabel =
    ROLE_OPTIONS.find(opt => opt.value === normalizedRole)?.label
    || authState.role;

  const fetchActivityUpdates = useCallback(async (page = 1, append = false) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) throw new Error("Access token not found");
      setActivityError("");

      const response = await fetch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/news-feed/?instanceId=${postObject.id}&limit=20&page=${page}&paginated=true`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      const nextUpdates = Array.isArray(data?.feeds) ? data.feeds : [];
      setActivityUpdates((current) => append ? [...current, ...nextUpdates] : nextUpdates);
      setActivityPage(page);
      setHasMoreActivity(Boolean(data?.hasMore));
    } catch (error) {
      console.error("Error fetching activity updates:", error);
      setActivityError("We couldn't load updates. Please try again.");
      setHasMoreActivity(false);
    } finally {
      setLoading(false);
      setLoadingActivity(false);
      setActivityLoaded(true);
    }
  }, [postObject.id]);

  const fetchCompanyUpdates = useCallback(async (page = 1, append = false) => {
    if (!postObject.id || !instanceUniqueId) return;
    setCompanyUpdatesError("");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/notes/my-updates`,
        {
          params: {
            instanceUniqueId,
            limit: 20,
            page,
            ...companyUpdateFilterParams({ activityFilter, hideCartChanges }),
          },
          headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
        }
      );
      const nextUpdates = Array.isArray(data?.updates) ? data.updates : [];
      setCompanyUpdates((current) => append ? [...current, ...nextUpdates] : nextUpdates);
      setCompanyUpdatesPage(page);
      setHasMoreCompanyUpdates(Boolean(data?.hasMore));
      setCompanyUpdatesUnfilteredTotal(Number(data?.unfilteredTotal) || 0);
    } catch (error) {
      console.error("Error fetching company updates:", error);
      setCompanyUpdatesError("We couldn't load company updates.");
      setHasMoreCompanyUpdates(false);
    } finally {
      setLoadingCompanyUpdates(false);
      setCompanyUpdatesLoaded(true);
    }
  }, [activityFilter, hideCartChanges, instanceUniqueId, postObject.id]);

  useEffect(() => {
    if (!postObject.id) return;
    setCompanyUpdates([]);
    setCompanyUpdatesPage(1);
    setHasMoreCompanyUpdates(true);
    setCompanyUpdatesLoaded(false);
    setActivityUpdates([]);
    setActivityPage(1);
    setHasMoreActivity(true);
    setActivityLoaded(false);
    setLoadingActivity(true);
  }, [postObject.id]);

  useEffect(() => {
    if (feedTab !== "company-updates" || companyUpdatesLoaded || !postObject.id) return;
    setLoadingCompanyUpdates(true);
    fetchCompanyUpdates(1, false);
  }, [companyUpdatesLoaded, feedTab, fetchCompanyUpdates, postObject.id]);

  useEffect(() => {
    if (feedTab !== "latest-updates" || activityLoaded || !postObject.id) return;
    setLoadingActivity(true);
    fetchActivityUpdates(1, false);
  }, [activityLoaded, feedTab, fetchActivityUpdates, postObject.id]);

  useEffect(() => {
    setCompanyUpdates([]);
    setCompanyUpdatesPage(1);
    setHasMoreCompanyUpdates(true);
    setCompanyUpdatesLoaded(false);
    setLoadingCompanyUpdates(true);
  }, [activityFilter, hideCartChanges]);

  const loadMoreVisibleFeed = useCallback(async () => {
    if (feedTab === "latest-updates") {
      if (loadingActivity || loadingMoreActivity || !hasMoreActivity) return;
      setLoadingMoreActivity(true);
      await fetchActivityUpdates(activityPage + 1, true);
      setLoadingMoreActivity(false);
      return;
    }
    if (loadingCompanyUpdates || loadingMoreCompanyUpdates || !hasMoreCompanyUpdates) return;
    setLoadingMoreCompanyUpdates(true);
    await fetchCompanyUpdates(companyUpdatesPage + 1, true);
    setLoadingMoreCompanyUpdates(false);
  }, [
    activityPage, companyUpdatesPage, feedTab, fetchActivityUpdates, fetchCompanyUpdates,
    hasMoreActivity, hasMoreCompanyUpdates, loadingActivity, loadingCompanyUpdates,
    loadingMoreActivity, loadingMoreCompanyUpdates,
  ]);

  useEffect(() => {
    const target = loadMoreRef.current;
    if (!target) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) loadMoreVisibleFeed(); },
      { rootMargin: '300px' }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [loadMoreVisibleFeed]);

  const togglePost = () => {
    setPostModal(!postModal);
  };

  const transformComments = (comments) => {
    return comments.map((comment) => ({
      userId: comment.user.id.toString(),
      comId: comment.id.toString(),
      fullName: `${comment.user.first_name} ${comment.user.last_name}`,
      userProfile: "", // Add user profile URL if available
      text: comment.comment,
      avatarUrl: "", // Add avatar URL if available
      timestamp: new Date(comment.createdAt).toISOString(),
      replies: [], // Populate this if there are nested replies
    }));
  };

  const handlePostStatus = async (item) => {
    // 1) Validate
    if (!userDetails?.role) return;
    if (item === "Broadcast" && userDetails.role !== "admin") {
      Swal.fire({ icon: "warning", title: "Not Authorized", text: "Only admins can broadcast.", heightAuto: false });
      return togglePost();
    }
    if (!statusTitle.trim() || !newStatus.trim()) {
      return Swal.fire({ icon: "warning", title: "Incomplete Details", text: "Enter both a title and a message.", heightAuto: false });
    }
  
    // 2) Build the request payload
    const payload = {
      instanceId: item === "Broadcast" ? null : postObject.id,
      title: statusTitle.trim(),
      message: newStatus.trim(),
      role: userDetails.role,
      tag: item === "Broadcast" ? "Broadcast by Admin" : "general",
    };
  
    // 3) Create a fully–shaped optimistic update
    const tempId = `temp-${Date.now()}`;
    const now = new Date().toISOString();
    const optimisticUpdate = {
      id: tempId,
      createdAt: now,
      title: payload.title,
      message: payload.message,
      tag: payload.tag,
      user: {
        id: userDetails.id,
        first_name: userDetails.first_name,
        last_name: userDetails.last_name,
        role: userDetails.role,
        profilePicture: userDetails.profilePicture ?? null,
      },
      comments: [],       // match your real shape
    };
  
    // 4) Show it immediately
    setActivityUpdates((prev) => [optimisticUpdate, ...prev]);
  
    // 5) Clear UI
    setStatusTitle("");
    setNewStatus("");
    togglePost();
  
    // 6) Fire off the real POST
    try {
      const res = await fetch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/news-feed/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) throw new Error(res.statusText);
      const { post } = await res.json();
  
      // 7) Replace the temp with the real item
      setActivityUpdates(prev =>
        prev.map(u =>
          u.id === tempId
            ? { ...u, ...post }
            : u
        )
      );
  
    } catch (err) {
      // 8) On failure, drop the temp and alert
      setActivityUpdates((prev) => prev.filter((u) => u.id !== tempId));
      Swal.fire({ icon: "error", title: "Post Failed", text: err.message, heightAuto: false });
    }
  };
  

  const handleOpenCommentDialog = () => {
    if (newStatus.trim() === "" || statusTitle.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Details",
        text: "Please enter both a title and a status message.",
        iconColor: "rgb(199, 9, 9)",
        confirmButtonColor: "#3085d6",
        heightAuto: false,
      });
      return;
    }
  
    // Open the dialog if both fields are filled
    setPostModal(true);
  };


  let history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
      axios
        .get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`
        )
        .then((response) => {
          setPostObject(response.data);
          setCheckIfCardIsValid(response.data.stripeCustomerId);

          // ✅ Save instance slug to localStorage
          const slug = response.data.instanceUniqueId;
          if (slug) {
            localStorage.setItem("instanceSlug", slug);
          }

          if (response.data.customUploadedBrandLogo != null) {
            setAvatarPreview(response.data.customUploadedBrandLogo);
          }
          setLoading(false);
        });
    }
  }, [authState.id]);

  let user = localStorage.getItem("accessToken");

  const onSubmit = (e) => {
    e.preventDefault();
    if (!canChangeBrandLogo) return;
    const data = new FormData();
    data.append("customUploadedBrandLogo", avatarField);
    data.append("chatId", instanceUniqueId);
    if (avatarField != "") {
      axios
        .post(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/update-core/brand-logo`,
          data,
          {
            headers: {
              accessToken: localStorage.getItem("accessToken"),
            },
          }
        )
        .then((response) => {
          toast.success("Your brand logo has been successfully updated.", {
            id: "brand-logo-updated",
          });
          setShowPopup(false);
        });
    } else {
      toast.error("You must upload a new brand logo in order to continue.", {
        id: "brand-logo-required",
      });
    }
  };
  function messagePopup() {
    if (!canChangeBrandLogo) return;
    setShowPopup(true);
  }
  function closePopup() {
    setShowPopup(false);
  }

  function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  }

  function generateAvatarUrl(name) {
    const initials = name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
    const backgroundColor = stringToColor(name).substring(1); // Remove the '#' from the color code
    return `https://ui-avatars.com/api/?name=${initials}&background=${backgroundColor}&color=fff&size=128`;
  }

  function generateAvatarSvg(name) {
    const initials = name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
    const backgroundColor = stringToColor(name);
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
        <rect width="100" height="100" fill="${backgroundColor}" />
        <text x="50%" y="50%" dy=".3em" text-anchor="middle" fill="#ffffff" font-size="50" font-family="Arial">
          ${initials}
        </text>
      </svg>
    `;
  }

  function svgToDataUrl(svg) {
    return `data:image/svg+xml;base64,${btoa(svg)}`;
  }

  const avatarSvg = generateAvatarSvg(
    userDetails ? userDetails.first_name : "Not Available"
  );
  const avatarUrl = svgToDataUrl(avatarSvg);

  const delPost = async (update) => {
    console.log(update);

    if (!update.id) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this post?"
    );
    if (!confirmDelete) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/news-feed/delete-feed/?id=${update.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const data = await response.json();

      if (data.success) {
        toast.success("Post deleted successfully!");
        // Optionally refresh the list or remove the deleted post from the UI
        fetchActivityUpdates(1, false);
      } else {
        toast.error("Failed to delete post.");
      }
    } catch (error) {
      console.error("Error deleting post:", error);
      toast.error("An error occurred while deleting the post.");
    }
  };

  const handleCommentDelete = async (commentId, data) => {
    console.log(commentId);
    console.log(data);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/news-feed/comment?commentId=${data.comIdToDelete}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.ok) {
        // Filter out the deleted comment from the state
        const updatedComments = comments.filter(
          (comment) => comment.comId !== data.comIdToDelete
        );
        toast.success("Comment Deleted Successfully");
        fetchActivityUpdates(1, false);
        // setComments(updatedComments);
        console.log("Delete successful");
      } else {
        toast.error("Something Went Wrong");
        console.error("Delete failed");
      }
    } catch (error) {
      console.error("An error occurred while deleting the comment:", error);
    }
  };

  // const handleCommentDelete = (update) => (comId) => {
  //   // The comId is directly passed from the CommentSection component when delete is clicked
  //   if (window.confirm("Are you sure you want to delete this comment?")) {
  //     fetch(`${process.env.REACT_APP_NODEJS_SERVER_URL}/news-feed/comment?commentId=${comId}`, {
  //       method: 'DELETE',
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     })
  //       .then(response => {
  //         if (response.ok) {
  //           // Refetch the updates to get the latest comments
  //           fetchActivityUpdates(1, false);
  //           console.log('Comment deleted successfully');
  //         } else {
  //           console.error('Delete failed');
  //         }
  //       })
  //       .catch(error => {
  //         console.error('An error occurred while deleting the comment:', error);
  //       });
  //   }
  // };

  const handleCommentEdit = (update) => async (data) => {
    console.log(data);
    const { comId, newValue } = data;
    console.log(comId);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/news-feed/comment?commentId=${comId}&comment=${data.text}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ comment: data.text }),
        }
      );

      if (!response.ok) {
        toast.error("Failed to delete post.");
        throw new Error("Failed to edit comment");
      }

      const updatedComment = await response.json();
      toast.success("Comment Edited Successfully");
      fetchActivityUpdates(1, false);

      // Update the local state to reflect the edited comment
      // setUpdates((prevUpdates) =>
      //   prevUpdates.map((upd) =>
      //     upd.id === update.id
      //       ? {
      //           ...upd,
      //           comments: upd.comments.map((comment) =>
      //             comment.id.toString() === comId
      //               ? { ...comment, comment: updatedComment.comment }
      //               : comment
      //           ),
      //         }
      //       : upd
      //   )
      // );
    } catch (error) {
      console.error("Error editing comment:", error);
      // Optionally, display an error message to the user
    }
  };

  console.log(activityUpdates);

  const showingCompanyUpdates = feedTab === "company-updates";
  const filteredCompanyUpdates = useMemo(() => filterCompanyUpdates(companyUpdates, {
    activityFilter,
    hideCartChanges,
  }), [activityFilter, companyUpdates, hideCartChanges]);
  const visibleUpdates = showingCompanyUpdates ? filteredCompanyUpdates : activityUpdates;
  const visibleLoading = showingCompanyUpdates ? loadingCompanyUpdates : loadingActivity;
  const visibleLoadingMore = showingCompanyUpdates ? loadingMoreCompanyUpdates : loadingMoreActivity;
  const visibleHasMore = showingCompanyUpdates ? hasMoreCompanyUpdates : hasMoreActivity;
  const visibleError = showingCompanyUpdates ? companyUpdatesError : activityError;
  const activeCompanyEmailView = useMemo(
    () => (activeCompanyEmailNote ? buildEmailViewerPropsFromNote(activeCompanyEmailNote) : null),
    [activeCompanyEmailNote]
  );

  return (
    <div className="instance-dashboard home">
      {showPopup && canChangeBrandLogo ? (
        <div className="popup update-logo">
          <div className="popup_inner">
            <h1>Update your brand logo</h1>
            <Formik>
              <Form>
                <div className="popup-content ">
                  <div className="lead-selection-section">
                    <label for="lead-full-name">
                      Update your current logo to a new design that will be
                      utilized in the dashboard and across your live chats.
                    </label>
                    <div className="brand-logo-preview-container">
                      <img className="brand-logo-preview" src={avatarPreview} />
                    </div>
                  </div>
                  <input
                    name="customUploadedBrandLogo"
                    accept="image/*"
                    id="contained-button-file"
                    type="file"
                    onChange={(e) => {
                      const fileReader = new FileReader();
                      fileReader.onload = () => {
                        if (fileReader.readyState === 2) {
                          setAvatarField(e.target.files[0]);
                          setAvatarPreview(fileReader.result);
                        }
                      };
                      if (e.target.files[0]) {
                        fileReader.readAsDataURL(e.target.files[0]);
                      }
                    }}
                  />
                  <div className="popup-button-group">
                    <button
                      type="submit"
                      onClick={onSubmit}
                      className="popup-button popup-button-save"
                    >
                      Upload logo
                    </button>
                    <button className="popup-button" onClick={closePopup}>
                      Close popup
                    </button>
                  </div>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      ) : (
        ""
      )}
      <InstanceLeftSidebar />
      <div className="rightSide">
        {loading == false ? (
          <div className="options-container fade-in-effect-usability">
            <div className="options-inner-container">
              <div className="core-user-container">
                <div className="core-user-credentials">
                  <div className="brand-logo">
                    <img //avatarPreview
                      className="brand-logo-preview"
                      src={getBrandLogoUrl()}
                      alt="Brand Logo Preview"
                    />
                  </div>
                  <div className="brand-name">
                    <h1>{postObject.instanceName}</h1>
                    <p className="uniqueCoreId">
                      {postObject.instanceUniqueId}
                    </p>
                    {postObject.typeOfCore == "promo-company" ? (
                      <>
                        <p className="type-of-live-core">
                          <AssistantIcon /> Promotional Distributor
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="core-user-actions">
                    {canChangeBrandLogo && (
                      <Link onClick={messagePopup} className="change-brand-logo">
                        <AddCircleIcon /> Change brand logo
                      </Link>
                    )}
                  {checkIfCardIsValid == "master" ? (
                    <div className="master-tag">Master account</div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {!loading && (
                <BirthdayWidget postObject={postObject} authState={authState} />
              )}
              {shouldShowFinanceFeedHome(authState) && (
                <FinanceFeedHome instanceUniqueId={instanceUniqueId} />
              )}
{/* —— Activity feed tabs —— */}
<div className="feed-toolbar">
  <div className="feed-tabs">
    <button className={feedTab === "latest-updates" ? "active" : ""} type="button" onClick={() => setFeedTab("latest-updates")}>
      <TimelineIcon fontSize="small" />
      Latest Updates
    </button>
    <button className={feedTab === "company-updates" ? "active" : ""} type="button" onClick={() => setFeedTab("company-updates")}>
      <BusinessOutlinedIcon fontSize="small" />
      Company Updates
    </button>
  </div>

  {showingCompanyUpdates && (
    <div className="company-update-controls">
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="company-activity-filter-label">Activity</InputLabel>
        <Select
          labelId="company-activity-filter-label"
          value={activityFilter}
          label="Activity"
          onChange={(event) => {
            setActivityFilter(event.target.value);
            if (event.target.value === "cart") setHideCartChanges(false);
          }}
        >
          {NOTE_ACTIVITY_FILTERS.map((option) => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Tooltip title="Filter company updates" arrow>
        <IconButton
          className="company-update-filter-button"
          aria-label="Filter company updates"
          aria-controls={companyFilterAnchorEl ? "company-updates-filter-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={companyFilterAnchorEl ? "true" : undefined}
          onClick={(event) => setCompanyFilterAnchorEl(event.currentTarget)}
          sx={{ color: hideCartChanges ? "primary.main" : "text.secondary" }}
        >
          <FilterAltIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  )}
</div>

{!showingCompanyUpdates && (
<div className="status-update-section">
  <h3><MessageIcon sx={{ fontSize: 18 }} /> Share an Update</h3>
  <TextField
    label="Status Title"
    variant="filled"
    fullWidth
    value={statusTitle}
    onChange={(e) => setStatusTitle(e.target.value)}
    className="status-input"
  />
  <TextField
    label="What's on your mind?"
    variant="filled"
    multiline
    rows={4}
    fullWidth
    value={newStatus}
    onChange={(e) => setNewStatus(e.target.value)}
    className="status-input"
  />
  <Button variant="contained" color="primary" onClick={handleOpenCommentDialog} className="status-submit-btn">
    Post Status
  </Button>
</div>
)}

{showingCompanyUpdates && (
  <>
      <Menu
        id="company-updates-filter-menu"
        anchorEl={companyFilterAnchorEl}
        open={Boolean(companyFilterAnchorEl)}
        onClose={() => setCompanyFilterAnchorEl(null)}
        PaperProps={{ sx: { width: 280, p: 1 } }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ px: 1, py: 0.75 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Filter company updates</Typography>
          <Typography variant="caption" color="text.secondary">
            Hide routine cart edits unless you want to review every cart change.
          </Typography>
        </Box>
        <Box sx={{ px: 1, py: 0.5 }}>
          <FormControlLabel
            sx={{ alignItems: "flex-start", m: 0 }}
            control={<Checkbox size="small" checked={hideCartChanges} onChange={(event) => setHideCartChanges(event.target.checked)} />}
            label={(
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>Hide cart changes</Typography>
                <Typography variant="caption" color="text.secondary">
                  Exclude cart updates, item edits, removals, and other routine cart activity.
                </Typography>
              </Box>
            )}
          />
        </Box>
        <Box sx={{ px: 1, pt: 0.5, display: "flex", justifyContent: "flex-end" }}>
          <Button size="small" onClick={() => setCompanyFilterAnchorEl(null)}>Close</Button>
        </Box>
      </Menu>
  </>
)}

<div className="activity-feed">
  {visibleError && (
    <div className="activity-post customer-updates-state">
      <Typography color="error">{visibleError}</Typography>
      <Button variant="text" onClick={() => showingCompanyUpdates ? fetchCompanyUpdates(1, false) : fetchActivityUpdates(1, false)}>Retry</Button>
    </div>
  )}
  {!visibleLoading && showingCompanyUpdates && visibleUpdates.length === 0 && companyUpdatesUnfilteredTotal > 0 && (
    <div className="activity-post customer-updates-state">
      <Typography variant="h6">No company updates match these filters.</Typography>
      <Button variant="text" onClick={() => { setActivityFilter("all"); setHideCartChanges(false); }}>Clear filters</Button>
    </div>
  )}
  {!visibleLoading && visibleUpdates.length === 0 && (!showingCompanyUpdates || companyUpdatesUnfilteredTotal === 0) && (
    <div className="activity-post customer-updates-state">
      <UpdateIcon color="action" sx={{ fontSize: 36, mb: 1 }} />
      <Typography variant="h6">{showingCompanyUpdates ? "No company updates yet" : "No updates yet"}</Typography>
      <Typography color="text.secondary">{showingCompanyUpdates ? "Updates from companies assigned to you will appear here." : "Instance activity will appear here."}</Typography>
    </div>
  )}
  {visibleUpdates.map((item) => {
    if (showingCompanyUpdates) {
      const meta = ACTION_META[item.action] || ACTION_META.update;
      const actionDefinition = getNoteActionDefinition(item.action);
      const authorName = [item.user?.first_name, item.user?.last_name].filter(Boolean).join(" ");
      const customerUrl = `/instance/${instanceUniqueId}/sales/customers?tab=all&openCustomer=${item.customerId}`;
      const projectUrl = item.orderId
        ? `/instance/${instanceUniqueId}/sales/orders/${encodeURIComponent(item.orderId)}/overview`
        : null;
      const isReceivedEmail = item.action === "inbound-project-email" && canViewEmailNote(item);
      const emailPreview = isReceivedEmail ? buildEmailNotePreview(item) : null;
      return (
        <div key={`customer-${item.id}`} className="activity-post" data-tag="customer-update">
          <div className="post-header">
            <div className="avatar" style={{ display: "flex", alignItems: "center" }}>
              <Tooltip title={authorName || "Customer update"} arrow>
                <img
                  src={item.user?.profilePicture?.startsWith("uploads") ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${item.user.profilePicture}` : item.user?.profilePicture || defaultAvatarUrl}
                  alt={authorName ? `${authorName} avatar` : "User avatar"}
                  style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                />
              </Tooltip>
              <ArrowForwardIcon sx={{ mx: 1 }} />
              <Tooltip title={item.customerName || "Customer"} arrow>
                <img
                  src={item.customerLogo?.startsWith("uploads") ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${item.customerLogo}` : item.customerLogo || "/elite-core-brand-logo.png"}
                  alt={`${item.customerName} logo`}
                  style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                />
              </Tooltip>
            </div>
            <div className="post-info">
              <h3 style={{ display: "flex", alignItems: "center", gap: 4 }}>{meta.icon}{actionDefinition?.label || meta.label || "Customer Updated"}</h3>
              <span className="timestamp">
                {formatDistanceToNow(new Date(item.timestamp), { addSuffix: true })}
                {authorName && ` • Updated by ${authorName}`}
              </span>
            </div>
          </div>
          <div className="post-content">
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              {item.customerName}: <Link className="company-update-view-link" to={customerUrl} target="_blank" rel="noopener noreferrer">View Customer</Link>
              {projectUrl && (
                <> · <Link className="company-update-view-link" to={projectUrl} target="_blank" rel="noopener noreferrer">View Project</Link></>
              )}
              {isReceivedEmail && (
                <>
                  {" · "}
                  <Button
                    size="small"
                    startIcon={<VisibilityIcon sx={{ fontSize: 16 }} />}
                    onClick={() => setActiveCompanyEmailNote(item)}
                    sx={{ p: 0, minWidth: 0, textTransform: "none", fontWeight: 700, verticalAlign: "baseline" }}
                  >
                    View email
                  </Button>
                </>
              )}
            </Typography>
            {emailPreview ? (
              <Box sx={{ fontSize: "0.875rem", lineHeight: 1.6, overflowWrap: "anywhere" }}>
                <div><strong>From:</strong> {emailPreview.party || "Unknown sender"}</div>
                <div><strong>Subject:</strong> {emailPreview.subject}</div>
                {emailPreview.bodyPreview && (
                  <div style={{ color: "#555" }}>{emailPreview.bodyPreview}</div>
                )}
                {emailPreview.attachmentCount > 0 && (
                  <div style={{ color: "#777", fontSize: "0.8rem" }}>
                    {emailPreview.attachmentCount} attachment{emailPreview.attachmentCount === 1 ? "" : "s"}
                  </div>
                )}
              </Box>
            ) : (
              <p dangerouslySetInnerHTML={{ __html: item.message }} />
            )}
          </div>
        </div>
      );
    }

    const update = item;
    return (
      <div key={`activity-${update.id}`} className="activity-post" data-tag={update.tag || "general"}>
        <div className="post-header">
          <div className="avatar" style={{ display: "flex", alignItems: "center" }}>
            <img src={getUserAvatar(update.user)} alt="User Avatar" />
          </div>
          <div className="post-info">
            <h3>{update.title}</h3>
            <span className="timestamp">
              {formatDistanceToNow(new Date(update.createdAt), { addSuffix: true })}{" "}
              • {update.user?.first_name} {update.user?.last_name}
            </span>
          </div>
        </div>
        <div className="post-content"><p>{update.message}</p></div>
        <div className="Post-Activities">
          <button
            type="button"
            className="ec-post-action-btn"
            onClick={() => toggleComments(update.id)}
            aria-expanded={openComments[update.id] || false}
            aria-label="Toggle comments"
          >
            <MessageCircle size={15} />
            <span>Comment{update.comments?.length > 0 && ` (${update.comments.length})`}</span>
          </button>
          <ReactionButtons update={update} accessToken={accessToken} />
          {(authState.id === update.user?.id || authState.role === "administrator") && (
            <button type="button" className="ec-post-action-btn danger" onClick={() => delPost(update)} aria-label="Delete post" style={{ marginLeft: "auto" }}>
              <Trash size={14} /><span>Delete</span>
            </button>
          )}
        </div>
        <Collapse in={openComments[update.id] || false}>
          <div className="ec-comment-area">
            <Comments comments={update.comments || []} />
            <CommentInput postId={update.id} onSubmit={handleCommentSubmit} />
          </div>
        </Collapse>
      </div>
    );
  })}
  {visibleHasMore && (
    <div ref={loadMoreRef} aria-hidden="true" style={{ height: 1 }} />
  )}
  {(visibleLoading || visibleLoadingMore) && (
    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}><CircularProgress size={24} /></Box>
  )}
  {!visibleHasMore && visibleUpdates.length > 0 && (
    <Typography align="center" color="text.secondary" sx={{ py: 2 }}>No more updates left.</Typography>
  )}
</div>

<EmailViewerDialog
  open={Boolean(activeCompanyEmailNote && activeCompanyEmailView)}
  email={activeCompanyEmailView}
  onClose={() => setActiveCompanyEmailNote(null)}
  title="Email Received"
/>

            { currentRoleLabel == "administrator" ?
            <>
              <div className="welcome-widget-box">
                <div className="inner-widget-box">
                  <div className="widget-heading">
                    <h3>
                      <span className="instance-badge-step-three">
                        Get started
                      </span>{" "}
                      Welcome to your live core dashboard
                    </h3>
                  </div>
                  <div className="widget-content">
                    <div class="widget-details">
                      <div className="column-60">
                        <p>
                          <strong>
                            Congratulations, Your live core is officially
                            launched!
                          </strong>{" "}
                          You can now explore the variety of design and
                          functional options that Elite Core offers. We
                          understand it can be a bit confusing to start
                          navigating your live core dashboard, which is why
                          we've created a short video that explains the
                          dashboard in its entirety.
                        </p>
                        <div className="step-3-actions">
                          <a href="#" className="continue-to-step-4">
                            Watch video <PlayCircleOutlineIcon />
                          </a>
                        </div>
                      </div>
                      <div className="column-40">
                        <img src="/welcome-to-elite-core/elite-core-instance-dashboard-welcome-message.png" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="archive-db-widget-box">
                <div className="inner-widget-box">
                  <div className="widget-heading">
                    <h3>Archives</h3>
                    <div className="widget-icon">
                      <TimelineIcon></TimelineIcon>
                    </div>
                  </div>
                  <div className="widget-details">
                    <span className="archive-statistics-number">
                      {listOfActiveCores.length}
                    </span>
                    <span className="archive-statistics-label">
                      Total orders launched
                    </span>
                    <Link
                      to={"/instance/" + instanceUniqueId + "/"}
                      className="archive-statistics-button"
                    >
                      View orders
                    </Link>
                  </div>
                </div>
              </div>
              <div className="leads-db-widget-box">
                <div className="inner-widget-box">
                  <div className="widget-heading">
                    <h3>Leads</h3>
                    <div className="widget-icon">
                      <FireplaceIcon></FireplaceIcon>
                    </div>
                  </div>
                  <div className="widget-details">
                    <span className="archive-statistics-number">
                      {listOfLeads.length}
                    </span>
                    <span className="archive-statistics-label">
                      Total leads generated
                    </span>
                    <Link
                      to={"/instance/" + instanceUniqueId + "/"}
                      className="archive-statistics-button"
                    >
                      View leads
                    </Link>
                  </div>
                </div>
              </div>

              <div className="analytics-db-widget-box">
                <div className="inner-widget-box">
                  <div className="widget-heading">
                    <h3>Create new web store</h3>
                    <div className="widget-icon">
                      <CodeIcon></CodeIcon>
                    </div>
                  </div>
                  <div className="widget-details">
                    <p>Ready to onboard customers onto their own web stores?</p>
                    <Link
                      to={"/instance/" + instanceUniqueId + "/"}
                      className="get-code-button"
                    >
                      Create a store
                    </Link>
                  </div>
                </div>
              </div>
              </>
              : "" }
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      { <Modal
        size="xs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={commentsModal}
      >
        <Modal.Header closeButton onClick={toggleComments}>
          <Modal.Title id="contained-modal-title-vcenter">Comments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Comments comments={comments} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <input
              type="text"
              className="form-control"
              placeholder="Type a Comment"
              value={postComment}
              onChange={(e) => setPostComment(e.target.value)}
            />
            <button
              type="button"
              // onClick={submitComment}
              className="btn btn-info text-white mx-1"
            >
              Post
            </button>
          </div>
        </Modal.Footer>
        <Modal.Footer>
          <Button onClick={toggleComments}>Close</Button>
        </Modal.Footer>
      </Modal>}
      <CommentsDialog
        open={postModal}
        onClose={togglePost}
        onChoice={handlePostStatus}
      />
    </div>
  );
}
const CommentsDialog = ({ open, onClose, onChoice }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="create-order-dialog"
    >
      <DialogTitle className="create-order-dialog-title">
        Post Status
      </DialogTitle>
      <DialogContent className="create-order-dialog-content">
        <Typography>
          Are you sure you want to post this status?
        </Typography>
      </DialogContent>
      <DialogActions className="create-order-dialog-actions">
        <Button
          onClick={() => onChoice("this-instance")}
          className="create-order-cancel-button"
        >
          Confirm Post
        </Button>
        <Button
          onClick={onClose}
          color="secondary"
          className="create-order-cancel-button"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};


/* ─────────────────────────────────────────────────────────
   Birthday Widget
   - Lists birthdays for a chosen month
   - “Add/Edit my birthday” inline
   - Admins can 1-click publish a monthly birthday post
   ───────────────────────────────────────────────────────── */

   const BirthdayWidget = ({ postObject, authState }) => {
    const [month, setMonth] = useState(new Date().getMonth() + 1); // 1..12
    const [loading, setLoading] = useState(false);
    const [people, setPeople] = useState([]);
    const [wrenchOpen, setWrenchOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [editDate, setEditDate] = useState(""); // yyyy-mm-dd
  
    const accessToken = localStorage.getItem("accessToken");
    const monthName = format(new Date(2025, month - 1, 1), "MMMM");
  
    // Parse YYYY-MM-DD safely as a LOCAL date (no TZ shift)
    const parseYmdLocal = (s) => {
      if (!s || typeof s !== "string") return null;
      const [y, m, d] = s.split("-").map((n) => parseInt(n, 10));
      if (!y || !m || !d) return null;
      return new Date(y, m - 1, d); // local time, midnight
    };
  
    const dayLabel = (yyyyMmDd) => {
      const dt = parseYmdLocal(yyyyMmDd);
      return dt ? format(dt, "MMM d") : (yyyyMmDd || "");
    };
  
    const fullAvatar = (profilePicture) => {
      if (!profilePicture) return "/elite-core-placeholder-avatar.png";
      try {
        const parsed = typeof profilePicture === "string" ? JSON.parse(profilePicture) : profilePicture;
        if (Array.isArray(parsed) && parsed.length) {
          const sel = parsed.find((p) => p.selected) || parsed[0];
          if (sel?.url?.startsWith("uploads")) {
            return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${sel.url}`;
          }
          return sel?.url || "/elite-core-placeholder-avatar.png";
        }
      } catch {
        if (typeof profilePicture === "string") {
          if (profilePicture.startsWith("uploads")) {
            return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${profilePicture}`;
          }
          return profilePicture;
        }
      }
      return "/elite-core-placeholder-avatar.png";
    };
  
    const fetchMonth = async (m = month) => {
      try {
        setLoading(true);
        const res = await fetch(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/birthdays?month=${m}&instanceUniqueId=${postObject.instanceUniqueId}`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        setPeople(Array.isArray(data.users) ? data.users : []);
      } catch (e) {
        console.error(e);
        toast.error("Could not load birthdays");
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchMonth(month);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [postObject.instanceUniqueId]);
  
    // Pre-fill edit date when opening wrench (if user already has one)
    useEffect(() => {
      const me = people.find((p) => String(p.id) === String(authState.id));
      if (me?.birthday) setEditDate(me.birthday);
    }, [people, authState.id]);
  
    const nextMonth = () => {
      const m = month === 12 ? 1 : month + 1;
      setMonth(m);
      fetchMonth(m);
    };
    const prevMonth = () => {
      const m = month === 1 ? 12 : month - 1;
      setMonth(m);
      fetchMonth(m);
    };
    const thisMonth = () => {
      const m = new Date().getMonth() + 1;
      setMonth(m);
      fetchMonth(m);
    };
  
    const openWrench = () => setWrenchOpen(true);
    const closeWrench = () => {
      if (saving) return; // lock during save
      setWrenchOpen(false);
    };
  
    const saveBirthday = async () => {
      if (!editDate) {
        toast.error("Pick a date first");
        return;
      }
      try {
        setSaving(true);
        const res = await fetch(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/update-birthday/${authState.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({ birthday: editDate }),
          }
        );
        if (!res.ok) throw new Error(await res.text());
        toast.success("Birthday saved!");
        setWrenchOpen(false);
        fetchMonth(month);
      } catch (e) {
        console.error(e);
        toast.error("Failed to save birthday");
      } finally {
        setSaving(false);
      }
    };
  
    return (
      <Box className="birthday-widget" sx={{ position: "relative" }}>
        {/* Header */}
        <div className="birthday-header" style={{ position: "relative", minHeight: 40 }}>
          {/* <Typography variant="h6" component="div" className="birthday-title">
            🎉 {monthName} Birthdays
          </Typography> */}

          <Typography
  variant="h6"
  component="div"
  className="birthday-title"
  sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
>
  {/* CelebrationIcon is the semantic replacement for the 🎉 emoji */}
  {/* <CelebrationIcon sx={{ fontSize: 20, color: "#7b1fa2" }} /> */}
  {/* <CelebrationIcon sx={{ fontSize: 20, color: "#e65100" }} /> */}
  <CelebrationIcon sx={{ fontSize: 20, color: "#d31c22" }} />
  {monthName} Birthdays
</Typography>
  
          {/* Absolute top-right icon controls */}
          <div
            className="birthday-controls-icons"
            style={{ position: "absolute", right: 8, top: 0, display: "flex", gap: 4 }}
          >
            <Tooltip title="Previous month">
              <IconButton size="small" onClick={prevMonth} aria-label="Previous month">
                <ChevronLeftIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="This month">
              <IconButton size="small" onClick={thisMonth} aria-label="This month">
                <TodayIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Next month">
              <IconButton size="small" onClick={nextMonth} aria-label="Next month">
                <ChevronRightIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Add / edit my birthday">
              <IconButton size="small" onClick={openWrench} aria-label="Add or edit my birthday">
                <BuildIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </div>
  
        {/* Body */}
        <Box className="birthday-body">
          {loading ? (
            <Typography variant="body2">Loading…</Typography>
          // ) : people.length === 0 ? (
          //   <Typography variant="body2" style={{ opacity: 0.8 }}>
          //     No birthdays found this month.
          //   </Typography>
          // ) 

          ) : people.length === 0 ? (
  <div className="ec-birthday-empty">
    <CelebrationIcon sx={{ fontSize: 28, color: "#e0e0e0" }} />
    <span>No birthdays in {monthName}</span>
  </div>
)
          
          : (
            <div className="birthday-list">
              {people.map((p) => {
                const name = `${p.first_name || ""} ${p.last_name || ""}`.trim();
                return (
                  <div className="birthday-chip" key={p.id}>
                    <img src={fullAvatar(p.profilePicture)} alt={name || "User"} />
                    <div className="chip-texts">
                      <strong>{name || "Unnamed"}</strong>
                      <span>{dayLabel(p.birthday)}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </Box>
  
        {/* Wrench Popup (uses your dialog classes) */}
        <Dialog
          open={wrenchOpen}
          onClose={(e, reason) => {
            if (saving && (reason === "backdropClick" || reason === "escapeKeyDown")) return;
            closeWrench();
          }}
          disableEscapeKeyDown={saving}
          className="create-order-dialog"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className="create-order-dialog-title">Add / Edit Birthday</DialogTitle>
          <DialogContent className="create-order-dialog-content">
            <div className="create-order-field-container">
              <TextField
                type="date"
                label="Your birthday"
                value={editDate || ""}
                onChange={(e) => setEditDate(e.target.value)}
                fullWidth
                className="create-order-input"
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </DialogContent>
          <DialogActions className="create-order-dialog-actions">
            <Button onClick={closeWrench} color="secondary" className="create-order-cancel-button" disabled={saving}>
              Cancel
            </Button>
            <Button onClick={saveBirthday} color="primary" disabled={saving} className="create-order-submit-button">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  };

 
const CommentInput = ({ postId, onSubmit }) => {
  const [text, setText] = React.useState("");

  const submit = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSubmit({ text: trimmed }, postId);
    setText("");
  };

  return (
    <div className="ec-comment-input-row">
      <TextField
        size="small"
        placeholder="Write a comment…"
        fullWidth
        variant="outlined"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            fontSize:     "0.85rem",
            fontFamily:   "Nunito",
            backgroundColor: "#fff",
          },
        }}
      />
      <Button
        variant="contained"
        size="small"
        disabled={!text.trim()}
        onClick={submit}
        sx={{
          textTransform: "none",
          fontWeight:    700,
          fontFamily:    "Nunito",
          borderRadius:  "8px",
          whiteSpace:    "nowrap",
          boxShadow:     "none",
          "&:hover":     { boxShadow: "none" },
        }}
      >
        Post
      </Button>
    </div>
  );
};
  
   

export default InstanceFeedAndActivity;
